export default __webpack_public_path__ + "static/media/Unoin-namad.70a7f898.png";